const ADJUSTMENT_REASON_BY_ADMIN = 'Call payments adjusted by acct. Admin.';

export default class CallService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  requestConversionAdjustment(accountId, data) {
    return this._RequestConversionUpdate(accountId, data, '/requestConversionAdjustment');
  }

  requestConversionOverride(accountId, data) {
    return this._RequestConversionUpdate(accountId, data, '/requestConversionOverride');
  }

  callPaymentOverride(accountId, data) {
    const requestData = {
      inboundCallId: data.inboundCallId,
      reason: ADJUSTMENT_REASON_BY_ADMIN,
      adjustConversion: data.adjustConversion,
      adjustPayout: data.adjustPayout,
      NewConversionAmount: data.conversionAdjustmentAmount,
      NewPayoutAmount: data.payoutAdjustmentAmount
    };

    const url = this._serviceBaseUrl(accountId) + '/payments/override';
    return this.$http.post(url, requestData);
  }

  callPaymentOverrideBulk(accountId, callIds, data) {
    const requestData = {
      CallIds: callIds,
      Reason: ADJUSTMENT_REASON_BY_ADMIN,
      AdjustConversion: data.adjustConversion,
      AdjustPayout: data.adjustPayout,
      AdjustConversionByAmount: data.conversionAdjustmentAmount,
      AdjustPayoutByAmount: data.payoutAdjustmentAmount
    };

    const url = this._serviceBaseUrl(accountId) + '/bulk/payments/override';
    return this.$http.post(url, requestData);
  }

  callPaymentOverrideBulkByLogs(accountId, callLogs, data) {
    const requestData = {
      CallLogs: callLogs,
      Reason: ADJUSTMENT_REASON_BY_ADMIN,
      AdjustConversion: data.adjustConversion,
      AdjustPayout: data.adjustPayout,
      AdjustConversionByAmount: data.conversionAdjustmentAmount,
      AdjustPayoutByAmount: data.payoutAdjustmentAmount
    };

    const url = this._serviceBaseUrl(accountId) + '/bulk/payments/calllogs/override';
    return this.$http.post(url, requestData);
  }

  getCallTranscription(accountId, callId) {
    const url = `${this._serviceBaseUrl(accountId)}/transcription/${callId}`;
    return this.$http.get(url);
  }

  transcribeMultipleCalls(accountId, callIds) {
    const requestData = {
      callIds: callIds
    };

    const url = `${this._serviceBaseUrl(accountId)}/transcription/bulk`;
    return this.$http.post(url, requestData);
  }

  transcribeMultipleCallsByLogs(accountId, callLog) {
    const url = `${this._serviceBaseUrl(accountId)}/transcription/bulk/calllog`;
    return this.$http.post(url, callLog);
  }

  _serviceBaseUrl(accountId) {
    return this.serviceBaseUri + accountId + '/calls';
  }

  _RequestConversionUpdate(accountId, data, endpointMethod) {
    const requestData = {
      inboundCallId: data.inboundCallId,
      reason: data.reason,
      amount: typeof data.conversionAdjustmentAmount !== 'undefined' ? data.conversionAdjustmentAmount : data.amount
    };

    const url = this._serviceBaseUrl(accountId) + endpointMethod;
    return this.$http.post(url, requestData);
  }
}